import { ButtonLink, Card, EmptyState } from '@/components/ui'
import { useDocumentTitle } from '@/lib/hooks'

export default function NotFoundPage() {
  useDocumentTitle('Not found')
  return (
    <Card>
      <EmptyState title="Page not found" description="That address isn't part of the console." action={<ButtonLink to="/dashboard">Go to dashboard</ButtonLink>} />
    </Card>
  )
}
